import React from "react";
import { mapEventTypeToDisplayStatus, useConsentStatusConfig } from "../../hooks/useConsentStatusConfig";
import { StatusBadge, Dot, StatusText } from "../Patient/ConsentStatusBadge.styled";

/**
 * ConsentStatusColumn Component
 * Displays consent status badge in table columns
 * @param {Object} record - Patient record with latestConsentEventType field
 */
export const ConsentStatusColumn = ({ record }) => {
  // Get the display status from latestConsentEventType
  const displayStatus = mapEventTypeToDisplayStatus(record.latestConsentEventType);

  // Get status configuration using shared hook
  const config = useConsentStatusConfig(displayStatus);

  return (
    <StatusBadge>
      <Dot color={config.dotColor} />
      <StatusText>{config.text}</StatusText>
    </StatusBadge>
  );
};

export default ConsentStatusColumn;
